import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import style from '@/views/components/cornerView/style.vue';

@Component({
  mixins: [style],
})
export default class CornerView extends Vue {
  @Prop() imgUrl;
  @Prop() selected;

  public img = '';

  public locationList: Array<any> = [
    {
      position: 'left',
      key: 1,
      selected: '1',
      isMask: false,
    },
    {
      position: 'lefts',
      key: 2,
      selected: '1',
      isMask: false,
    },
    {
      position: 'right',
      key: 3,
      selected: '2',
      isMask: false,
    },
    {
      position: 'rights',
      key: 4,
      selected: '2',
      isMask: false,
    },
    {
      position: 'bottom',
      key: 5,
      selected: '5',
      isMask: false,
    },
    {
      position: 'bottoms',
      key: 6,
      selected: '5',
      isMask: false,
    },
    {
      position: 'bigbottom',
      key: 7,
      selected: '5',
      isMask: false,
    },
  ];

  onmouseup(val) {
    if (this.imgUrl) {
      this.locationList.map((item, index) => {
        if (item.key == val) {
          item.isMask = true;
        }
      });
    }
  }

  onmouseleave(val) {
    this.locationList.map((item, index) => {
      item.isMask = false;
    });
  }

  deleteImg() {
    this.$emit('deleteImg');
  }

  render(h) {
    return (
      <div class="cornerView">
        <div class="listbox">
          {this.selected
            && this.locationList.map((item, index) => {
              if (item.selected == this.selected) {
                if (item.position == 'left') {
                  return (
                    <div class="leftcorner" on-mouseenter={this.onmouseup.bind(this, item.key)} on-mouseleave={this.onmouseleave.bind(this, item.key)}>
                      {this.imgUrl && <el-image class="image" src={this.imgUrl} fit="fit"></el-image>}
                      {item.isMask && (
                        <div class="mask">
                          <i class="el-icon-delete" onClick={this.deleteImg.bind(this)}></i>
                        </div>
                      )}
                    </div>
                  );
                } else if (item.position == 'lefts') {
                  return (
                    <div class="leftcorner1" on-mouseenter={this.onmouseup.bind(this, item.key)} on-mouseleave={this.onmouseleave.bind(this, item.key)}>
                      {this.imgUrl && <el-image class="image" src={this.imgUrl} fit="fit"></el-image>}
                      {item.isMask && (
                        <div class="mask">
                          <i class="el-icon-delete" onClick={this.deleteImg.bind(this)}></i>
                        </div>
                      )}
                    </div>
                  );
                } else if (item.position == 'right') {
                  return (
                    <div class="rightcorner" on-mouseenter={this.onmouseup.bind(this, item.key)} on-mouseleave={this.onmouseleave.bind(this, item.key)}>
                      {this.imgUrl && <el-image class="image" src={this.imgUrl} fit="fit"></el-image>}
                      {item.isMask && (
                        <div class="mask1">
                          <i class="el-icon-delete" onClick={this.deleteImg.bind(this)}></i>
                        </div>
                      )}
                    </div>
                  );
                } else if (item.position == 'rights') {
                  return (
                    <div class="rightcorner1" on-mouseenter={this.onmouseup.bind(this, item.key)} on-mouseleave={this.onmouseleave.bind(this, item.key)}>
                      {this.imgUrl && <el-image class="image" src={this.imgUrl} fit="fit"></el-image>}
                      {item.isMask && (
                        <div class="mask1">
                          <i class="el-icon-delete" onClick={this.deleteImg.bind(this)}></i>
                        </div>
                      )}
                    </div>
                  );
                } else if (item.position == 'bottom') {
                  return (
                    <div class="bottomcorner" on-mouseenter={this.onmouseup.bind(this, item.key)} on-mouseleave={this.onmouseleave.bind(this, item.key)}>
                      {this.imgUrl && <el-image class="image hei-38 wid-75" src={this.imgUrl} fit="fit"></el-image>}
                      {item.isMask && (
                        <div class="mask2">
                          <i class="el-icon-delete" onClick={this.deleteImg.bind(this)}></i>
                        </div>
                      )}
                    </div>
                  );
                } else if (item.position == 'bottoms') {
                  return (
                    <div class="bottomcorner1" on-mouseenter={this.onmouseup.bind(this, item.key)} on-mouseleave={this.onmouseleave.bind(this, item.key)}>
                      {this.imgUrl && <el-image class="image hei-38 wid-75" src={this.imgUrl} fit="fit"></el-image>}
                      {item.isMask && (
                        <div class="mask2">
                          <i class="el-icon-delete" onClick={this.deleteImg.bind(this)}></i>
                        </div>
                      )}
                    </div>
                  );
                }
              }
            })}
        </div>
        <p class="title r-pl-46 line-height-40 left wid-193">商品详情示意图</p>
        <div class="detailbox">
          {this.selected == '5'
            && this.locationList.map((item, index) => {
              if (item.position == 'bigbottom') {
                return (
                  <div class="bottomcorner2" on-mouseenter={this.onmouseup.bind(this, item.key)} on-mouseleave={this.onmouseleave.bind(this, item.key)}>
                    {this.imgUrl && <el-image class="image wid-166 hei-86" src={this.imgUrl} fit="fit"></el-image>}
                    {item.isMask && (
                      <div class="mask3">
                        <i class="el-icon-delete" onClick={this.deleteImg.bind(this)}></i>
                      </div>
                    )}
                  </div>
                );
              }
            })}
        </div>
      </div>
    );
  }
}
